var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',{style:(("background: linear-gradient(180deg, #262626 18.75%, #009E53 99.48%); width: " + (_vm.$vuetify.breakpoint.width) + "; height: 100vh")),attrs:{"id":"app","fluid":""}},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }